const env = require('../helpers/env.js');
const hasOpenTokSupport = require('./hasOpenTokSupport.js').once;

module.exports = () => hasOpenTokSupport() && ['Chrome', 'Safari'].indexOf(env.name) !== -1;
